import constConf from '../../../constconf'
import axios from 'axios'

export default {
    secretClientTaskAll: (context, botId) => {
        let url = constConf.client.url + '/secret-client/task-all/' + botId
        context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                if (response.ok === true) {
                    context.commit('secretClientTaskAll', response.response.data)
                } else {
                    context.commit('secretClientTaskAll', [])
                }
            })
    },
    secretClientVoteAll: (context, botId) => {
        let url = constConf.client.url + '/secret-client/vote-all/' + botId
        context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                if (response.ok === true) {
                    context.commit('secretClientVoteAll', response.response.data)
                } else {
                    context.commit('secretClientVoteAll', [])
                }
            })
    }
}
